import React, { cloneElement } from "react";

const ProgressNavigation = ({ children, membershipIncludesAkasse }) => {
    let stepsToRender = children;

    if (membershipIncludesAkasse === true) {
        stepsToRender = children.map((child) => {
            const { ...restProps } = child.props;
            restProps.disabled = false;
            restProps.isPreviousToDisabled = false;
            return cloneElement(child, restProps);
        });
    } else {
        const disabledIndex = children.findIndex(
            (child) => child.props.disabled === true
        );

        if (disabledIndex > 0) {
            stepsToRender = children.map((child, index) =>
                cloneElement(child, {
                    isPreviousToDisabled: index === disabledIndex - 1,
                })
            );
        }
    }
    return (
        <nav className="progress-navigation">
            <ol className="progress-navigation__steps">{stepsToRender}</ol>
        </nav>
    );
};

export default ProgressNavigation;
